/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2025, Zumper
 */

import { createLoggerInterface } from '@zcode/logger'

export const { logger, setLogger, setLogLevel } = createLoggerInterface()
